import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getRegions = () => api.get("/regions").then((r) => r.data);
export const getRegion = (id) => api.get(`/regions/${id}`).then((r) => r.data);
export const getTours = (params) => api.get("/tours", { params }).then((r) => r.data);
export const getRecentAdventure = () => api.get("/recent-adventure").then((r) => r.data);
export const getCallingCard = () => api.get("/calling-card").then((r) => r.data);
export const getTour = (slug) => api.get(`/tours/${slug}`).then((r) => r.data);
export const getTourExperience = (slug) => api.get(`/tours/${slug}/experience`).then((r) => r.data);
export const createSavedExperience = (payload) => api.post(`/experiences`, payload).then((r) => r.data);
export const getSavedExperience = (token) => api.get(`/experiences/${token}`).then((r) => r.data);
export const getBlog = () => api.get("/blog").then((r) => r.data);
export const submitContact = (payload) => api.post("/contact", payload).then((r) => r.data);
export const createJourney = (payload) => api.post("/journeys", payload).then((r) => r.data);
export const getJourney = (id) => api.get(`/journeys/${id}`).then((r) => r.data);
export const askAssistant = (payload) => api.post("/ai/recommend", payload).then((r) => r.data);
export const requestTradeAccess = (payload) => api.post("/trade-access-requests", payload).then((r) => r.data);

// 'What to expect' podcast (Raj x Simone), grounded in the RA journal
export const getPodcast = (slug) => api.get(`/tours/${slug}/podcast`).then((r) => r.data);
export const generatePodcast = (slug) => api.post(`/tours/${slug}/podcast`).then((r) => r.data);
export const podcastAudioUrl = (slug) => `${API}/tours/${slug}/podcast/audio`;

// Booking workflow
export const getWorkflowConfig = () => api.get("/workflow/config").then((r) => r.data);
export const createEnquiry = (payload) => api.post("/enquiries", payload).then((r) => r.data);
export const createReservation = (payload) => api.post("/reservations", payload).then((r) => r.data);
export const createCallRequest = (payload) => api.post("/call-requests", payload).then((r) => r.data);

// Australian market — Stripe checkout (AUD)
export const createCheckout = (payload) => api.post("/payments/checkout", payload).then((r) => r.data);
export const getPaymentStatus = (sessionId) => api.get(`/payments/status/${sessionId}`).then((r) => r.data);

// 'Living Memory' trip dashboards (magic link)
export const mediaUrl = (u) => (!u ? u : u.startsWith("http") ? u : `${BACKEND_URL}${u}`);
export const getTrip = (token) => api.get(`/trip/${token}`).then((r) => r.data);
export const tripWelcomeAudioUrl = (token) => `${API}/trip/${token}/welcome-audio`;
export const uploadTripPhoto = (token, formData) => api.post(`/trip/${token}/photos`, formData).then((r) => r.data);
export const deleteTripPhoto = (token, id) => api.delete(`/trip/${token}/photos/${id}`).then((r) => r.data);

// Marketing Partner Network — public campaign landing + lead capture
export const getPublicCampaign = (code) => api.get(`/campaigns/${code}`).then((r) => r.data);
export const createLead = (payload) => api.post(`/mpn/leads`, payload).then((r) => r.data);
export const createBooking = (payload) => api.post(`/mpn/book`, payload).then((r) => r.data);
export const getBooking = (ref) => api.get(`/mpn/bookings/${ref}`).then((r) => r.data);
export const payBooking = (ref, payload) => api.post(`/mpn/bookings/${ref}/pay`, payload).then((r) => r.data);

// Commission shown to logged-in trade/agency partners (display only)
export const COMMISSION_RATE = 0.15;
